module.exports = __webpack_public_path__ + "img/black_board_a001_title.b09ec8b2.png";